import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/catch";
import {documentosEnviados, errorEnviandoDocumentos} from "./actions";
import {catchError, map, mergeMap} from "rxjs/operators";
import * as types from "./types";
import {ofType} from "redux-observable";
import {RequestWrapper} from "../../../request/RequestWrapper/RequestWrapper";

export const enviarDocumentosEpic = (action$) => {
  return action$.pipe(
    ofType(types.ENVIAR_DOCUMENTOS),
    mergeMap((action: any) => RequestWrapper
      .secureUpload(`/gestion-contenido-empresarial/api/recepcion-documental/comandos/recaptcha/archivos` +
        `?nombreComando=RecibirDocumentosPorInternet` +
        `&tipoSolicitud=${action.payload.tipoSolicitud}` +
        `&idSolicitud=${action.payload.idSolicitud}`,
        action.payload,
        action.payload.files
      )
      .pipe(map(response => documentosEnviados(response)),
        catchError((error) => {
            if (error.response) {
              return [errorEnviandoDocumentos(error.response)];
            } else {
              if (error.status === 504) {
                return [errorEnviandoDocumentos("Error técnico de timeout")];
              } else {
                return [errorEnviandoDocumentos("Por favor, comunícate con uno de nuestros asesores.")];
              }
            }
        }),
      )));
};
